import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

/**
 * Get student quiz data
 * @param {*} [queryParams={}] - query params to be passed to the request
 * @param {boolean} [skip=false] - Used to skip the query if required values are not present
 */
const useLazyStudentQuizGet = (queryParams = {}, skip = false) => {
  let resource = `${MONOLITH_ORIGIN}/api/v3/studentquiz/`;
  const queryString = new URLSearchParams(queryParams).toString();

  resource = `${resource}?${queryString}`;
  return useLazyRestQuery(resource, { skip });
};

export default useLazyStudentQuizGet;
